import { getInstanceName } from '../helpers/utils';

const siteName = getInstanceName().toLowerCase().replace(' ', '');

export const EMAIL_MEDIA = `media@${siteName}.com`;
export const EMAIL_GENERAL = `info@${siteName}.com`;
export const EMAIL_SUPPORT = 'https://help.livesupportnow.com/hc/en-gb';
export const EMAIL_CAREERS = `careers@${siteName}.com`;
